export class ContentsUrl {
  private constructor() {
    //
  }

  static get instance() {
    return new ContentsUrl();
  }
  // カスタマイズしたコードを表示するURLを取得
  getUrl(project_id: string, user_id: number): string {
    const protocol = location.protocol;
    let url = protocol + '//' + this.getExecmodeHost() + '/show_user_contents';
    url += '?user_id=' + user_id + '&project_id=' + project_id + '';
    return url;
  }

  // URLを取得
  getUrlWithCurrentHost(project_id: string, user_id: number): string {
    const protocol = location.protocol;
    let url = protocol + '//' + window.location.host + '/show_user_contents';
    url += '?user_id=' + user_id + '&project_id=' + project_id + '';
    return url;
  }

  getContentsURLEncode(project_id: string, user_id: number): string {
    return encodeURIComponent(this.getUrl(project_id, user_id));
  }

  /**
   * location.pathから現在ファイルのベースディレクトリまでのパスを取得
   */
  getBasePath = (location_path: string): string => {
    let base_path = '';
    const pathArray = location_path.split('/');
    for (let i = 0; i < pathArray.length - 1; i++) {
      base_path += pathArray[i];
      base_path += '/';
    }
    return base_path;
  };

  /**
   * 現在ページのコンテキストURLを返す
   */
  getBaseURL = (location_obj: Location): string => {
    const base_path = this.getBasePath(location_obj.pathname);
    let url = '';
    //  url += location_obj.protocol + "//" ;
    url += location_obj.host;
    url += base_path;
    return url;
  };

  getCurrentHost = function (): string {
    return location.protocol + '//' + location.host;
  };

  getCurrentLocation = function (): string {
    return this.getCurrentHost() + location.pathname;
  };

  /**
   * ホストの次のディレクトリのパスを返す
   * @return {[type]} [description]
   */
  getContextPath = function (): string {
    const directorys = location.pathname.split('/');
    const path = directorys.length > 0 ? directorys[1] : '';
    return this.getCurrentHost() + '/' + path;
  };

  /**
   * ホストの次のディレクトリのパスを返す
   * @return {[type]} [description]
   */
  getRestParam = (layer = 0): string => {
    const directorys = location.pathname.split('/').reverse();
    // console.log(directorys, location.pathname);
    const path = directorys.length > 0 ? directorys[layer] : '';
    return path;
  };

  get contextPathByRun(): string {
    const directorys = location.pathname.split('/');
    const path = directorys.length > 0 ? directorys[1] : '';
    if (location.host == 'blockvrock.com') {
      return location.protocol + '//run.blockvrock.com/' + path;
    } else {
      return location.protocol + '//' + location.host + '/' + path;
    }
  }

  getExecmodeHost(): string {
    let host = 'run.blockvrock.com';
    if (location.host.indexOf('blockvrock.com') < 0) {
      // if( !is.include(location.host,"blockvrock") ){
      host = location.host;
    }
    return host;
  }

  insertFrameContents(elementId, contents): void {
    // お手本の実行(srcdoc対応ブラウザはこれだけでOK)

    contents = contents.replace(/run.blockvrock.com/g, 'blockvrock.com');
    document.querySelector(elementId).innerHTML = contents;
    // document.querySelector(elementId).setAttribute('srcdoc', contents);
  }

  // クラスルームのURLを取得
  getClassRoomUrl(user_id: number, className:string,token: string): string {
    const protocol = location.protocol;
    let url = protocol + '//' + this.getBaseURL(location) + 'class_room';
    url += '/' + user_id + '/' + className+ '?token=' + token + '';
    return url;
  }
}
